// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"3246c6ee","214":"a0c8837a"}[chunkId] + ".css";
};